import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import TabContainer from '@/components/common/TabContainer';
import EditIcon from '@/components/Icons/EditIcon';
import PlusIcon from '@/components/Icons/PlusIcon';
import ViewIcon from '@/components/Icons/ViewIcon';
import Layout from '@/components/Layout/Layout';
import {
  IDeptResponse,
  TDeptDesignationResponse,
} from '@/interfaces/attendance.model';
import { IFilterSideBarForm } from '@/interfaces/common.model';
import { IDepartmentList } from '@/interfaces/department.model';
import { IDesignation } from '@/interfaces/designation.mode';
import {
  IEmployeeList,
  IEmployeeOnBoardResponse,
} from '@/interfaces/employee.model';
import { setUpdateFilterStates } from '@/redux/features/UserSlice';
import { RootState } from '@/redux/store';
import ExportDataHandler from '@/utility/CommonFunctions';
import {
  getFilterUrl,
  orderByList,
  showToastNotification,
} from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import moment from 'moment';
import { ITableRowData } from '@/interfaces/common.model';
import { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { IDesignationResponse } from '../Designation/Designation';
interface IPageStates {
  tableLoader: boolean;
  employeeData: ITableData[];
  departmentList: IDepartmentList[];
  designationList: IDesignation[];
  searchQuery: string;
  isExit?: boolean;
}
interface ITableData extends ITableRowData {
  id: string;
  index: number;
  empNameWithImage: string;
  employeeCode: string | number;
  phone: string;
  email: string;
  dateOfJoin: string;
  employeeExitAt?: string;
  department: string;
  role: string;
  employeeStatus: string;
  salary?: boolean;
}
const EmployeeOnBoard: React.FC = () => {
  const timeoutId = useRef<NodeJS.Timeout | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const location = useLocation();
  const isEmployeeRoute = location.pathname === RoutesLink.employees;
  const [pageStates, setPageStates] = useState<IPageStates>({
    tableLoader: false,
    employeeData: [],
    departmentList: [],
    designationList: [],
    searchQuery: '',
    isExit: false,
  });
  // const toggle = () => {
  //   setIsOpen(!isOpen);
  // };
  console?.log('pageStates', pageStates?.employeeData);
  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'index', label: '#' },
    { value: 'empNameWithImage', label: 'Emp. Name' },
    { value: 'employeeCode', label: 'Emp. Code' },
    { value: 'department', label: 'Department' },
    { value: 'role', label: 'Designation' },
    { value: 'phone', label: 'Phone No.' },
    { value: 'email', label: 'Email' },
    { value: 'dateOfJoin', label: 'Joining Date' },
    // ...(filterDetails?.empStatus || filterDetails?.status === 'exEmployee'
    //   ? ([{ value: 'employeeExitAt', label: 'Exit Date' }] as const)
    //   : []),
    { value: 'employeeStatus', label: 'Status' },
    ...(!isEmployeeRoute
      ? ([{ value: 'salary', label: 'Salary' }] as const)
      : []),
  ];
  const actionData = [
    {
      label: 'View',
      className: 'btn btn-link',
      icon: <ViewIcon />,
      title: 'view',
      clickHandler: (data: ITableData) => handleView(data),
    },
    ...(!isEmployeeRoute
      ? [
          {
            label: 'Edit',
            className: 'btn btn-link',
            icon: <EditIcon />,
            title: 'edit',
            clickHandler: (data: ITableData) =>
              navigate(RoutesLink?.editEmployeeOnBoard + `/${data?.id}`),
          },
        ]
      : []),
  ];
  const handleView = (data: ITableData) => {
    if (isEmployeeRoute) {
      navigate(RoutesLink?.detailEmployee + `/${data?.id}`);
    } else {
      navigate(RoutesLink?.employeeDetail + `/${data?.id}`);
    }
  };
  const getEmployeeList = useCallback(async () => {
    const filter = {
      departmentId: filterDetails.department,
      orderBy: filterDetails?.orderBy,
      search: pageStates.searchQuery,
      designationId: filterDetails.designation,
      pageSize: filterDetails?.pageSize,
      pageNumber: filterDetails.currentPage,
      status: filterDetails?.empStatus,
    };
    try {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: true,
        employeeData: [],
      }));
      const response: IEmployeeOnBoardResponse = await callApi(
        API_URL + API_ENDPOINT.getEmployee + '?' + getFilterUrl(filter),
        { method: 'GET' },
      );
      if (response?.status) {
        const newData: ITableData[] = response?.data?.user?.map(
          (item, index) => ({
            ...item,
            index: index + 1,
            empNameWithImage: item?.name + '##' + item?.profilePhoto,
            employeeCode: item?.employeeCode ?? '-',
            phone: item?.phone,
            email: item?.email,
            employeeStatus: item?.status,
            department: item?.department?.name ?? '-',
            role: item?.designation?.name ?? '-',
            salary: item?.isSalaryCreated,
            dateOfJoin: item?.joiningDate
              ? moment(item?.joiningDate).format('DD-MMM-YYYY')
              : '--',
            employeeExitAt: item?.employeeExitAt
              ? moment(item?.employeeExitAt).format('DD-MMM-YYYY')
              : '--',
          }),
        );
        setPageStates((prevStates) => ({
          ...prevStates,
          employeeData: newData,
          isExit: true,
        }));
        dispatch(
          setUpdateFilterStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          }),
        );
      }
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
    }
  }, [
    filterDetails.department,
    filterDetails?.orderBy,
    pageStates.searchQuery,
    filterDetails.designation,
    filterDetails?.pageSize,
    filterDetails.currentPage,
    filterDetails?.empStatus,
    dispatch,
  ]);
  const getDesignations = useCallback(async (departmentId: string) => {
    try {
      const response: IDesignationResponse = await callApi(
        API_URL + API_ENDPOINT.getDesigantion + `?departmentId=${departmentId}`,
        { method: 'GET' },
      );
      if (response?.status) {
        setPageStates((prev) => ({
          ...prev,
          designationList: response?.data?.designation,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  }, []);

  const sortHandler = (
    data: Partial<IFilterSideBarForm> | null,
    type?: string | null,
  ) => {
    if (type === 'department' && data) {
      getDesignations(data?.department ?? '');
    } else {
      dispatch(
        setUpdateFilterStates({
          ...(type === 'site' && { siteId: data?.site }),
          ...(!type && { department: data?.department }),
          ...(!type && { designation: data?.designation }),
          ...(!type && {
            empStatus: data?.status === 'all' ? '' : data?.status,
          }),
          ...(type == 'companyId' && {
            companyId: data?.companyId,
            siteId: '',
            currentPage: 1,
          }),
        }),
      );
    }
  };
  useEffect(() => {
    getEmployeeList();
  }, [getEmployeeList]);
  const handleChangePageSize = (value: number) => {
    dispatch(
      setUpdateFilterStates({
        currentPage: 1,
        pageSize: value,
      }),
    );
  };
  const pageChangeHandler = (PageNo: number) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        setUpdateFilterStates({
          currentPage: PageNo,
        }),
      );
    }
  };
  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    timeoutId.current = setTimeout(() => {
      dispatch(setUpdateFilterStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };
  const orderByHandler = (e: ChangeEvent<HTMLSelectElement>) => {
    dispatch(
      setUpdateFilterStates({
        orderBy: e.target.value,
        currentPage: 1,
      }),
    );
  };
  const handleExport = () => {
    const data = {
      exportDataType: 'user',
      ...(filterDetails?.empStatus ? { status: filterDetails.empStatus } : {}),
      ...(filterDetails?.department
        ? { departmentId: filterDetails.department }
        : {}),
      ...(filterDetails?.designation
        ? { designationId: filterDetails.designation }
        : {}),
    };
    ExportDataHandler(data);
  };

  const getDepartmentAndDesignation = useCallback(async (id: string) => {
    const url = API_URL + API_ENDPOINT.getDesigantion + `?departmentId=${id}`;
    const res: TDeptDesignationResponse = await callApi(url, { method: 'GET' });
    if (res?.status === true) {
      const data = res.data;
      if ('designation' in data) {
        setPageStates((pre) => ({
          ...pre,
          designationList: data.designation,
        }));
      }
    }
  }, []);

  const loadDepartmentAndDesignation = useCallback(async () => {
    const deptRes: IDeptResponse = await callApi(
      API_URL + API_ENDPOINT.getDepartment,
      { method: 'GET' },
    );
    if (deptRes?.status === true) {
      const departments = deptRes.data.department;
      setPageStates((pre) => ({
        ...pre,
        departmentList: departments,
      }));
      const firstDeptId = departments?.[0]?.id;
      if (firstDeptId) {
        getDepartmentAndDesignation(firstDeptId);
      }
    }
  }, [getDepartmentAndDesignation]);

  useEffect(() => {
    loadDepartmentAndDesignation();
  }, [loadDepartmentAndDesignation]);
  const employeeList: IEmployeeList = {
    department: pageStates?.departmentList,
    designation: pageStates?.designationList,
  };

  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title={!isEmployeeRoute ? 'Employee Onboard' : 'Employees'}
            buttonText={!isEmployeeRoute ? 'Add Employee' : ''}
            buttonIcon={!isEmployeeRoute ? <PlusIcon /> : null}
            buttonLink={!isEmployeeRoute ? RoutesLink.addEmployeeOnBoard : ''}
          />
          <TabContainer>
            <FilterComponent
              handleExport={
                !isEmployeeRoute && pageStates?.employeeData?.length > 0
                  ? handleExport
                  : null
              }
              filterArray={{
                isShow: true,
              }}
              userStatus={true}
              employeeList={employeeList}
              sortHandler={sortHandler}
              handleSearch={handleSearchChange}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
            />
            <CommonTable<ITableData>
              handleViewDetail={handleView}
              tableHeading={tableHeading}
              tableData={pageStates.employeeData}
              ActionData={actionData}
              currentPage={filterDetails?.currentPage}
              pageChangeHandler={pageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={filterDetails?.totalPages}
              count={filterDetails?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={filterDetails.pageSize}
            />
          </TabContainer>
        </div>
      </Layout>
      {/* <ConfirmModal
        isOpen={isOpen}
        toggle={toggle}
        submitHandler={() => {}}
        isLoading={false}
      /> */}
    </>
  );
};
export default EmployeeOnBoard;
